import QTable from 'quasar/src/components/table/QTable.js';

export const baseCampaignsTableColumn = (): QTable['columns'] => [
  {
    name: 'id',
    field: 'id',
    label: 'شماره کمپین',
    align: 'center'
  },
  {
    name: 'title',
    field: 'title',
    label: 'عنوان',
    align: 'left',
    classes: 'max-width-200'
  },
  {
    name: 'status',
    field: 'status',
    label: 'وضعیت',
    align: 'center'
  },
  {
    name: 'running_at',
    field: 'running_at',
    label: 'تاریخ پرداخت',
    align: 'center'
  },
  {
    name: 'persian_type',
    field: 'persian_type',
    label: 'نوع',
    align: 'center'
  },
  {
    name: 'actions',
    field: '',
    label: '',
    align: 'right'
  }
]

export function getLastCampaignsTableColumns(): QTable['columns'] {
  return [
    {
      name: 'id',
      label: 'شماره کمپین',
      field: 'id',
      align: 'left'
    },
    {
      name: 'title',
      label: 'عنوان کمپین',
      field: 'title',
      align: 'left',
      style: 'max-width:250px;min-width:150px'
    },
    {
      name: 'items_count',
      label: 'تعداد مقالات',
      field: 'items_count',
      align: 'left',
    },
    {
      name: 'running_at',
      label: 'تاریخ ثبت',
      field: 'running_at',
      align: 'left'
    },
    {
      name: 'status',
      label: 'وضعیت',
      field: 'status',
      align: 'left'
    },
    {
      name: 'operation',
      label: '',
      field: 'operation',
      align: 'left'
    }
  ]
}
